export default {
    titlePlaceholder: 'Type your title',
    messagePlaceholder: 'Type Something',
    upgradeMembership: 'Upgrade membership to chat',
    sendPicture: 'Send picture',
    sendVoice: 'Send voice message',
    sendVideo: 'Send video',
    send: 'Send',
    audioNotSupported: 'Your browser does not support the audio tag',
    videoNotSupported: 'Your browser does not support the video tag',
    addTitle: 'You must add a title',
    addAudio: 'You have not recorded a voice message',
    upgradeToListen: 'Upgrade to listen to full audio',
    upgradeToWatch: 'Upgrade to watch full video',
    upgradeToView: 'Upgrade to view image',
    upgradePopup: 'Upgrade for full access',
    subscribe: 'Subscribe',
    emptyContactsList: 'Your contacts list is empty',
    emptyContactsList2: 'for people to chat with',
    search: 'Search'
}
